import { useEffect } from 'react';
import { backButton } from '@tma.js/sdk-react';
import { useNavigate } from 'react-router-dom';
import { isInTelegram } from '../telegram';

interface BackButtonProps {
    onClick?: () => void;
}

export function BackButton({ onClick }: BackButtonProps) {
    const navigate = useNavigate();

    useEffect(() => {
        if (!isInTelegram()) return;

        const handleBack = onClick || (() => navigate(-1));

        backButton.show();
        const off = backButton.onClick(handleBack);

        return () => {
            off();
            backButton.hide();
        };
    }, [onClick, navigate]);

    return null;
}
